import { Icon, type IconTypes } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import s from './copy-project-toast.module.scss';

export const COPY_PROJECT_TOAST_CLASS = s.toast;

interface CopyProjectToastShellProps {
    iconName: IconTypes;
    title: string;
    children: ReactNode;
}

export function CopyProjectToastShell({
    iconName,
    title,
    children,
}: CopyProjectToastShellProps): ReactNode {
    return (
        <div className="flex flex-row gap-3 align-items-start min-w-0 flex-auto">
            <Icon
                fontSize="normal"
                className="p-toast-message-icon"
                name={iconName}
            />
            <div className="flex flex-column gap-1 align-items-start min-w-0 w-full">
                <strong className="p-toast-message-title">{title}</strong>
                {children}
            </div>
        </div>
    );
}
